document.addEventListener("DOMContentLoaded", function () {
  // Coordenadas
  const lat = -16.299933807911515;
  const lng = -48.9532603843798;

  // Inicialização do mapa
  const map = L.map('map-canvas', {
    center: [lat, lng],
    zoom: 14,
    scrollWheelZoom: false,
    dragging: false,
    zoomControl: false,
  });

  // Adicionar tiles (fundo do mapa)
  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; OpenStreetMap contributors'
  }).addTo(map);

  // Conteúdo do popup (equivalente ao InfoWindow)
  const content = `
    <div id="iw-container" style="max-width: 350px;">
      <div class="img-map">
        <img src="//usequantum.com.br/cdn/shop/t/6/assets/logo.png?v=73096882057788210411746638355" alt="Logo" style="width: 100px; height: auto;" />
      </div>
      <div class="content-map">
        <div class="addres-map">Rua 7, Antônio Fernandes, Anápolis, Goiás, Brasil</div>
        <div class="map-contact">
          <div class="phone-map">Phone : <span>(62) 98238-1922</span></div>
          <div class="email-map">Email : <span>contato@usequantum.com.br</span></div>
        </div>
      </div>
    </div>
  `;

  // Adicionar o marcador
  const marker = L.marker([lat, lng], {
    title: ""
  }).addTo(map);

  // Popup
  marker.bindPopup(content).openPopup();
});